export default "__VITE_ASSET__BF0hc6Xo__"